module.exports = __webpack_public_path__ + "img/ic-log-in-white.0a3fe31f.svg";